import { apiClient, API_PRX } from '@indipia/shared';

// 스튜디오_개선_설계서_v3.0 §9 (FR-27~30) — 좌측 내비·하단 고정 영역·플라이아웃(스튜디오
// 설정/알림/사용자 정보)·우측상단 고객센터를 구성하는 항목을 TM_MENU 조회로 대체한다.

export type MenuPositionCode = 'LEFT_TOP' | 'LEFT_BOTTOM' | 'DOCK_PANEL' | 'FLYOUT_PANEL' | 'RIGHT_TOP' | 'BOTTOM' | 'FULL_SCREEN' | 'TASK_GUIDE';
export type MenuTypeCode = 'LINK' | 'GROUP_HEADER' | 'FLYOUT_ROOT' | 'COLLAPSE_GROUP';
export type MenuLinkTargetCode = 'SCREEN_PUSH' | 'FLYOUT_OPEN' | 'MODAL' | 'ACTION_ONLY';

export interface MenuNode {
  menuId: number;
  parentMenuId: number | null;
  positionCode: MenuPositionCode;
  typeCode: MenuTypeCode;
  linkTarget: MenuLinkTargetCode | null;
  code: string;
  name: string;
  /** TM_MENU.ICON_KEY — 아이콘 파일명(확장자 제외) 또는 아이콘 URL. 비어 있으면 기본 아이콘 */
  iconKey: string | null;
  routePath: string | null;
  sortOrder: number;
  level: number;
  /** 화면(LNB/플라이아웃/할일) 노출 여부 — 라우팅과 무관, 렌더링 시점에만 참고한다.
   *  알림·현장요약 라우팅(resolveMenuCodeAction 등)은 이 값을 보지 않고 그대로 이동한다. */
  displayYn: 'Y' | 'N';
  children: MenuNode[];
}

/**
 * GET /indipia/menus?portalCode=... — 포털 메뉴 트리 조회(N1). 역할 필터링은 서버가 수행.
 * portalCode를 생략하면 전체 포털을 대상으로 조회한다(알림·현장요약 라우팅 전용 — webMenuCode/
 * appMenuCode가 WEB_STUDIO 외의 포털(WEB_PHOTO/WEB_SCHEDULE 등 "할일" 포털)에 등록된 경우도
 * 찾아야 하기 때문. 좌측 내비 렌더링은 계속 portalCode='WEB_STUDIO'로 스코프를 좁혀서 쓴다).
 */
export async function fetchMenus(portalCode?: string): Promise<MenuNode[]> {
  const res = await apiClient.get(`${API_PRX.INDIPIA}/menus`, { params: portalCode ? { portalCode } : {} });
  return (res.data.data?.menus ?? []) as MenuNode[];
}
